export const positions = {
  header: 'Manage Positions',
  subHeader: 'You do not have any existing positions',
  edit: {
    tabName: 'Edit Position',
    infoBanner: 'Changes do not apply to jobs that are currently posted. If you need to make position changes to existing jobs, those must be done on the jobs themselves.'
  },
  create: {
    header: 'Create a Position',
    button: 'Create a new position',
  },
  subtitle:
    'Every job post begins with a position. Once created, we’ll save it so you don’t have to start jobs from scratch!',
  createButton: 'Create a position',
  disclaimer:
    'Once a position is used, you can\'t change it. If you need to update any details, just copy the position, make your changes, and save it as a new one. This keeps things clear and simple.',
  table: {
    title: 'Name',
    createdBy: 'Created By',
    lastEdited: 'Last Edited',
    activeJobs: 'Active Jobs',
    search: 'Position name, creator...',
    archive: '%position% has been deleted.',
    copy: 'You have created a copy of %position% and are now able to edit any details of this new position.',
    copyFailed: 'Unable to copy position. Please try again or contact support.',
  },
  deleteTooltip: 'This position is being used by one or more active jobs',
  editTooltip:
    'This position has been used by one or more jobs in the past, so it is no longer editable',
  editSuccessful: 'We have saved your %title% position',
  createSuccessfull:
    'Succesfully created your new position. Now you can edit the position as needed.',
  confirmDelete: {
    title: 'Are you sure you want to delete %position%?',
    body: 'This action cannot be undone.',
    confirm: 'Yes, delete position',
  },
};
